<template>
  <v-container fluid style="display: flex; flex-direction: column; align-items: stretch; justify-content: flex-start; height: 93vh;">

  <div v-if="loading && hasReservoirSelection" class="reservoir-loading-state">
    <div class="reservoir-loading-state__header">
      <v-progress-circular indeterminate size="22" width="2" color="primary" />
      <span>Carregando reservatórios...</span>
    </div>
    <div class="reservoir-loading-state__cards">
      <v-skeleton-loader
        v-for="index in 2"
        :key="index"
        type="card"
        class="reservoir-loading-card"
      />
    </div>
    <v-skeleton-loader type="image" class="reservoir-loading-chart" />
  </div>
  <div
    v-else-if="reservoirLoadError || !hasReservoirSelection"
    class="reservoir-empty-state"
  >
    <div class="reservoir-empty-state__icon">
      <v-icon size="36" color="#2563EB">{{ reservoirEmptyState.icon }}</v-icon>
    </div>
    <h2>{{ reservoirEmptyState.title }}</h2>
    <p>{{ reservoirEmptyState.description }}</p>
    <v-btn
      v-if="reservoirLoadError"
      color="primary"
      outlined
      small
      @click="reloadDate"
    >
      Tentar novamente
    </v-btn>
  </div>
  <div
    v-if="showReservoirs && !loading"
    class="top-section"
  >
    <v-row
      style="flex-wrap: nowrap; overflow-x: auto; overflow-y: hidden; white-space: nowrap; width: 100%; padding-bottom: 8px; height: auto;"
    >
      <v-col
        cols="auto"
        v-for="(reservoir, i) in listSectors"
        :key="i"
        style="flex: 0 0 auto; margin-right: 12px;"
      >
        <v-card style="width: 400px; border-radius: 16px; overflow: hidden; box-shadow: 0 2px 8px #0001;" :style="{backgroundColor: hexToRgba(colors[i % colors.length], 0.3)}">
          <v-card-title class="d-flex align-center" style="padding-bottom: 0;">
            <span style="font-weight: 500; font-size: 0.95rem; color: #545454; display: flex; align-items: center;">{{ reservoir.unitTitle || 'Unidade' }}</span>
            <div style="display: flex; width: 100%; align-items: center;">
              <span style="font-weight: 600; font-size: 1.2rem; color: #1C1C1C; display: flex; align-items: center;">{{ reservoir.name }}</span>
            </div>
            <div style="font-size: 0.95rem;font-weight: 500; color: #545454; padding: 0 ; margin-top: 2px; margin-bottom: 0;">
              Última Atualização: <span style="font-weight: 500;">{{ reservoir.lastDate }}</span>
            </div>
          </v-card-title>

          <v-card-text style="padding-top: 8px; position: relative;"> 
            <div style="position: absolute; left: 0; z-index: 0;" 
            :style="{ top: (110 - ((reservoir.reservoirLevel ? reservoir.reservoirLevel.waterVolume : 0)/reservoir.reservoirVolume ) *90) + '%' }"> 
              <v-img class="masked-gradient" :style="{backgroundColor: colors[i % colors.length]}"style="height: 300px;width: 400px;"></v-img> 
            </div>
            <div style="position: absolute; left: 0; z-index: 0;"
            :style="{ top: ((110 -((reservoir.reservoirLevel ? reservoir.reservoirLevel.waterVolume : 0)/reservoir.reservoirVolume) *110)) + '%' }" > 
              <v-img class="masked-gradient reverse-mask" :style="{backgroundColor: colors[i % colors.length]}"style="height: 300px;width: 400px;"></v-img> 
            </div>
            <v-row style="position: relative; z-index: 1;"> 
              <v-col cols="6" style="padding-right: 0;">
                <LevelBar
                  :maxLevel="reservoir.reservoirHeight"
                  :currentLevel="reservoir.reservoirLevel ? reservoir.reservoirLevel.waterHeight : 0"
                  :minimumLevel="reservoir.reservoirMinHeight"
                  :maxVolume="reservoir.reservoirVolume"
                  :currentVolume="reservoir.reservoirLevel ? reservoir.reservoirLevel.waterVolume : 0"
                  :unitMeasure = "unitMeasureVuex"
                />
              </v-col>

              <v-col cols="6" style="justify-content: flex-end; display: flex; align-items: flex-end;">
                <div class="consumption-kpi">
                  <!-- <div style="color: #1C1C1C;font-size: 10px;">Consumo</div>
                  <div style="color: #1C1C1C;font-size: 18px;font-weight: 600;word-wrap: break-word;text-align: center;width: 100%;white-space: normal;">
                    {{ reservoir.reservoirVolume - reservoir.reservoirLevel.waterVolume  }} L
                  </div>
                  <v-divider class="my-3" style="width: 100px;"></v-divider> -->
                  <div style="color: #1C1C1C;font-size: 10px;white-space: nowrap;text-align: center;">Capacidade</div>
                  <div style="color: #1C1C1C;font-size: 18px;font-weight: 600;white-space: nowrap;text-align: center;">
                    {{ reservoir.currentCapacityPercentage || 0 }} %
                  </div>
                </div>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </div>

  <div v-if="multiReadings.length  > 0 && !loading" class="bottom-section">
    <div style="background: #f9fafd; border-radius: 16px; box-shadow: 0 2px 8px #0001;padding: 8px; height: 100%;">
      <ChartsReservoirLevel 
        style="height: 100%; display: flex;" 
        :labels="multiReadings[0].labels"
        :readings="multiReadings" />
    </div>
  </div>

  </v-container>

</template>

<script>
import LevelBar from './LevelBar.vue';
import ReservoirLevelScript from './ReservoirLevelScript.js';
export default ReservoirLevelScript;
</script>

<style lang="scss">
.top-section {
  height: auto;
  overflow-y: hidden;
  overflow-x: auto;
}

.bottom-section {
  height: auto;
  flex: 1 1 auto;
  padding-top: 0px;
  overflow: hidden;
}

.litte {
  left: 10px;
}

.reservoir-empty-state {
  flex: 1 1 auto;
  min-height: 320px;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 10px;
  padding: 32px 20px;
  color: #334155;
  text-align: center;
}

.reservoir-empty-state__icon {
  width: 64px;
  height: 64px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 4px;
  background: #EFF6FF;
  border: 1px solid #DBEAFE;
  border-radius: 8px;
}

.reservoir-empty-state h2 {
  margin: 0;
  font-size: 20px;
  font-weight: 600;
  letter-spacing: 0;
}

.reservoir-empty-state p {
  max-width: 460px;
  margin: 0 0 6px;
  color: #64748B;
  font-size: 14px;
}

.reservoir-loading-state {
  flex: 1 1 auto;
  width: 100%;
  padding: 20px 8px;
}

.reservoir-loading-state__header {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 16px;
  color: #475569;
  font-size: 14px;
  font-weight: 500;
}

.reservoir-loading-state__cards {
  display: flex;
  gap: 16px;
  overflow: hidden;
}

.reservoir-loading-card {
  flex: 0 0 400px;
  max-width: 400px;
  border-radius: 8px;
  overflow: hidden;
}

.reservoir-loading-chart {
  width: 100%;
  height: 220px;
  margin-top: 20px;
  border-radius: 8px;
  overflow: hidden;
}

.consumption-total-style {
  display: flex;
  justify-content: center;
  margin: 10px 0px 10px 0px;
}

.date-picker-height {
  height: 450px
}

.style-div {

  display: flex;
  //justify-content: space-evenly;
  justify-content: flex-start;

}

.layout-data-abstract-fields {
  padding-top: 0px !important;
  padding-bottom: 0px !important;
}

.layout-data-abstract {
  background: #1976d2 !important;
  border-radius: 1rem !important;


}

.masked-gradient {
  position: relative;
  -webkit-mask-image: url('./Wave.svg');
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-size: cover;
  -webkit-mask-position: 0 0;
  mask-image: url('./Wave.svg');
  mask-repeat: no-repeat;
  mask-size: cover;
  mask-position: 0 0;
  animation: moveMask 5s linear infinite alternate;
}

@keyframes moveMask {
  0% { -webkit-mask-position: 0 0; mask-position: 0 0; }
  100% { -webkit-mask-position: 100% 0; mask-position: 100% 0; }
}

.reverse-mask {
  opacity: 0.7;
  animation: moveMask 3s linear infinite alternate;
  animation-direction: alternate-reverse;
}

.style-card-city-name {
  background: #3298ed !important;

  text-align: center !important;
  border-radius: 1rem;
  padding: 1rem;
  font-size: 1rem;
  word-break: normal;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;

  span {
    color: white;
    font-style: italic;
  }
}

.v-divider {
  border-color: white;
  border-width: 0.05rem;
}

.consumption-kpi{
  background-color: white;
  width: 50%;
  height: 30%;
  display: flex;
  padding: 12px;
  border-radius: 10px;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  word-break: keep-all;
  white-space: nowrap;
  min-width: fit-content;
}

.card-style-data-client {
  color: white !important;
  background: #1976d2 !important;
  text-align: center !important;
  border-style: none !important;
  font-size: 1rem !important;
}

.v-text-field-bar-class {
  border-style: none !important;
}

.text-large {
  font-size: 225%;
  font-weight: 500;
}

.cards {
  padding-top: 5px !important;
  padding-bottom: 4px !important;
  padding-left: 15px !important;
  padding-right: 10px !important;
}

.ticketCards {
  padding-left: 10px !important;
  padding-right: 10px !important;
}

.cardsLG {
  margin-bottom: 5px !important;
  padding-left: 6px !important;
  padding-right: 6px !important;
  padding-top: 0px !important;
  padding-bottom: 0px !important;
}

.ticketCardsLG {
  margin-bottom: 5px !important;
  padding-left: 10px !important;
  padding-right: 10px !important;
  padding-top: 0px !important;
  padding-bottom: 0px !important;
}

.cardsBigger {
  padding-bottom: 4px !important;
  padding-left: 15px !important;
  padding-right: 10px !important;
}

.cardsBiggerLG {
  margin-bottom: 5px !important;
  padding-left: 6px !important;
  padding-right: 6px !important;
}
</style>
